import { render, staticRenderFns } from "./MdMemoCN.vue?vue&type=template&id=532be5d8&"
import script from "./MdMemoCN.vue?vue&type=script&lang=js&"
export * from "./MdMemoCN.vue?vue&type=script&lang=js&"
import style0 from "./MdMemoCN.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports